import { render, staticRenderFns } from "./ProductsTableRowCustomFields.vue?vue&type=template&id=d8a8bc5e&"
import script from "./ProductsTableRowCustomFields.vue?vue&type=script&lang=js&"
export * from "./ProductsTableRowCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTableRowCustomFields.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./ProductsTableRowCustomFields.vue?vue&type=style&index=1&lang=scss&module=CustomField&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["CustomField"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports